import React from "react";
import { Plus } from "lucide-react";
import { formatPrice } from "../../lib/api";

const BundleUpsell = ({ bundles, onAdd }) => (
  <section className="border-t border-line bg-bone">
    <div className="container-x py-16">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-8">
        <div className="md:col-span-7">
          <p className="overline mb-3">Build your rotation</p>
          <h2 className="font-display uppercase text-3xl md:text-4xl tracking-tightest font-bold leading-[0.95]">
            Save when you pack the rotation.
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line">
        {bundles.map((b) => (
          <div key={b.slug} className="bg-white p-6 flex flex-col" data-testid={`upsell-${b.slug}`}>
            <div className="flex items-center justify-between">
              <span className="mono text-xs text-mute">
                {b.pairs} pair{b.pairs > 1 ? "s" : ""}
              </span>
              {b.saving > 0 && (
                <span className="mono text-[10px] tracking-widest uppercase px-2 py-1 bg-pritch-volt-trim text-ink">
                  Save {formatPrice(b.saving)}
                </span>
              )}
            </div>
            <h3 className="font-display uppercase text-2xl tracking-tightest font-bold leading-[1] mt-4">
              {b.name}
            </h3>
            <p className="mt-3 text-sm text-mute flex-1">{b.description}</p>
            <div className="mt-5 flex items-center justify-between border-t border-line pt-4">
              <p className="mono text-base">{formatPrice(b.price)}</p>
              <button
                type="button"
                onClick={() => onAdd(b)}
                className="inline-flex items-center gap-2 text-[11px] tracking-[0.18em] uppercase font-bold hover:gap-3 transition-all"
                data-testid={`upsell-add-${b.slug}`}
              >
                <Plus size={14} /> Add bundle
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BundleUpsell;
